import React, { Component, forwardRef } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin, { Draggable } from '@fullcalendar/interaction'
import { toggleTaskModal } from 'actions/campaign/addOrEdit'
import { schedulerMounted } from 'actions/tasks'
import { withRouter } from 'react-router-dom'
import './main.scss'

const mapStateToProps = (state) => ({
  tasksByID: state.tasks.tasksByID,
  taskModalOpen: state.campaign.addOrEdit.taskModalOpen,
})

const styles = (theme) => ({
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  button: {
    margin: theme.spacing.unit,
  },
  floatingActionButton: {
    position: 'fixed',
    bottom: '23px',
    right: '23px',
    color: '#fff',
  },
  progress: {
    margin: theme.spacing.unit * 2,
  },
  root: {
    flexGrow: 1,
    border: 'solid 1px #adadad',
    borderRadius: 35,
    overflow: 'hidden',
  },
  gridItem: {
    padding: theme.spacing.unit * 2,
    color: theme.palette.text.secondary,
  },
})

class SchedulerComponent extends Component {
  componentDidMount() {
    this.props.schedulerMounted(true)

    let draggableEl = document.getElementById('draggableCampaignPageTaskTypes')

    if (draggableEl) {
      new Draggable(draggableEl, {
        itemSelector: '.draggableCampaignPageTaskType',
        eventData: function (eventEl) {
          let title = eventEl.getAttribute('title')
          let id = eventEl.getAttribute('data')
          return {
            title,
            id,
            allDay: false,
            startTime: '00:00',
          }
        },
      })
    }
  }

  componentWillUnmount() {
    this.props.schedulerMounted(false)
  }

  // handleEventClick = e => {
  //   e.preventDefault()
  //   if (e.event.id === 0) {
  //     this.props.history.push(`/tasks/new?date=${e.event.start.toISOString()}`)
  //   } else {
  //     this.props.history.push(`/tasks/${e.event.id}`)
  //   }
  // }

  removeEvent = (info) => {
    info.event.remove()
  }

  render() {
    const {
      classes,
      tasksByID,
      ownedBy,
      toggleTaskModal,
      forwardedRef,
      history,
    } = this.props

    const taskObj = {
      1: { name: 'send_email', when: 'when_to_send' },
      2: { name: 'send_sms', when: 'when_to_send' },
      4: { name: 'add_contacts_to_group', when: 'when_to_trigger' },
      5: { name: 'remove_contacts_from_group', when: 'when_to_trigger' },
      6: { name: 'move_contacts_btwn_groups', when: 'when_to_trigger' },
    }

    const eventData = Object.values(tasksByID)
      .filter((task) => {
        if (ownedBy) {
          return (
            task?.[taskObj?.[task?.task_type_id]?.name]?.[
              taskObj?.[task.task_type_id]?.when
            ] &&
            task?.owned_by &&
            task?.owned_by.id === ownedBy?.id &&
            task?.owned_by.type === ownedBy?.type
          )
        }
        return true
      })
      .map((task) => {
        const whenToSendDate =
          task?.[taskObj?.[task?.task_type_id]?.name]?.[taskObj?.[task?.task_type_id]?.when]

        return {
          id: task.id,
          start: whenToSendDate,
          end: whenToSendDate,
          title: task.description,
        }
      })

    return (
      <div className={classes.root}>
        <div className="demo-app-calendar">
          <FullCalendar
            defaultView="dayGridMonth"
            header={{
              // left: 'today prev,next title',
              center: 'title',
              // right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek',
            }}
            plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
            ref={forwardedRef}
            weekends
            events={eventData}
            dateClick={(e) => {
              let now = new Date()
              now.setHours(0, 0, 0, 0)

              if (
                e.date &&
                Object.prototype.toString.call(e.date) === '[object Date]' &&
                e.date >= now
              ) {
                if (ownedBy) {
                  toggleTaskModal({ date: e.date })
                } else {
                  this.props.history.push(
                    `tasks/new?date=${e.date.toISOString()}`,
                  )
                }
              }
            }}
            eventClick={(e) =>
              ownedBy
                ? toggleTaskModal({ taskID: e.event.id })
                : history.push(`tasks/${e.event.id}`)
            }
            droppable
            drop={(eventDropInfo) => {
              toggleTaskModal({
                date: eventDropInfo.date,
                taskTypeID: eventDropInfo.draggedEl.id.split('-')[0],
                campaign: true,
              })
            }}
            eventReceive={(info) => {
              this.removeEvent(info)
            }}
            allDayDefault={false}
            allDaySlot={false}
            height="parent"
          />
        </div>
      </div>
    )
  }
}

const Scheduler = withRouter(
  connect(mapStateToProps, (dispatch) =>
    bindActionCreators({ toggleTaskModal, schedulerMounted }, dispatch),
  )(withStyles(styles)(SchedulerComponent)),
)

export default forwardRef((props, ref) => (
  <Scheduler forwardedRef={ref} {...props} />
))
